import { render, staticRenderFns } from "./AddEditInstrument.vue?vue&type=template&id=28be7a96&"
import script from "./AddEditInstrument.vue?vue&type=script&lang=js&"
export * from "./AddEditInstrument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports